export const parseWithoutThrowingException = (json, shouldLogError) => {
  try {
    return JSON.parse(json);
  } catch (e) {
    shouldLogError && console.error(`Failed to parse json: ${json}\n${e}`);
  }
};
